import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import Footer from "../component/Footer";
import Header from "../component/Header";
import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from "yup";

import { useLocation, useNavigate } from 'react-router-dom'
const schema = yup.object().shape({



});

const Success = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const { name, transactionNumber, amount } = location.state || {}
    console.log("Received from location.state ->", name, transactionNumber, amount);


    return (

        <>
            <Header />

            <section className="page-header bg_img"
                style={{
                    backgroundImage: "URL(./images/banner2.jpg)",
                    height: "30lvh",
                }}
            >
                <div className="container">
                    <div className="page-header-content">
                        <h1 className="title">Success</h1>
                        <ul className="breadcrumb">
                            <li>
                                <a href="/">Home</a>
                            </li>

                            <li> Success </li>
                        </ul>
                    </div>
                </div>
            </section>
            <div className="student-page">


                <section className="teacher-section py-3 bg_img ">
                    <div className="container">

                        <div className="cart-checkout-box mb-widget"></div>
                        <Card className="text-center">
                            <Card.Header>
                                <h4 className="text-success">Payment Successful</h4>
                            </Card.Header>
                            <Card.Body>
                                <p className="fs-5">Thank you </p>
                                <p>Your payment of <strong>{amount}</strong> has successful</p>
                                {/* <p><strong>Transaction ID:</strong> {transactionNumber}</p> */}
                                {/* <Button color="primary" onClick={() => navigate('/dashboard')}>
                                Go to Dashboard
                            </Button> */}
                            </Card.Body>
                        </Card>




                    </div>
                </section >
                <Footer />
            </div>
        </>

    );
}
export default Success;